export default class HttpService {
  baseURL = 'https://gosalbezehijos.com/entrypoint';
  headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  _fetch = ( _endpoint, _options = {} ) => {
    return new Promise( ( resolve, reject ) => {
      fetch( _endpoint, _options )
        .then( ( response ) => response.json() )
        .then( resolve )
        .catch( reject );
    });
  }

  GET = ( endpoint ) => {
    let _endpoint = this.baseURL + endpoint;

    return this._fetch( _endpoint );
  }

  POST = ( endpoint, values ) => {
    let _endpoint = this.baseURL + endpoint;
    let _options = {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify( values )
    };
    
    return this._fetch( _endpoint, _options );
  }

  PUT = ( endpoint, values ) => {
    let _endpoint = this.baseURL + endpoint;
    let _options = {
      method: 'PUT',
      headers: this.headers,
      body: JSON.stringify( values )
    };
    
    return this._fetch( _endpoint, _options );
  }

  DELETE = ( endpoint ) => {
    let _endpoint = this.baseURL + endpoint;
    let _options = {
      method: 'DELETE',
      headers: this.headers
    };
    
    return this._fetch( _endpoint, _options );
  }

  getClients = () => {
    return new Promise( ( resolve, reject ) => {
      this
        .GET( '/insurance/clients' )
        .then( resolve )
        .catch( reject );
    });
  }

  saveClient = ( values ) => {
    let endpoint = '/insurance/clients';

    return new Promise( ( resolve, reject ) => {
      if( values.id !== undefined ) {
        this
          .PUT( endpoint + '/' + values.id, values )
          .then( resolve )
          .catch( reject );
      } else {
        this
          .POST( endpoint, values )
          .then( resolve )
          .catch( reject );
      }
    });
  }

  

  getPolicies = () => {
    return new Promise( ( resolve, reject ) => {
      this
        .GET( '/insurance/policies' )
        .then( resolve )
        .catch( reject );
    });
  }

  savePolicy = ( values ) => {
    let endpoint = '/insurance/policies';

    return new Promise( ( resolve, reject ) => {
      if( values.id !== undefined ) {
        console.log( 'PUT', values );
        this
          .PUT( endpoint + '/' + values.id, values )
          .then( resolve )
          .catch( reject );
      } else {
        console.log( 'POST', values );
        this
          .POST( endpoint, values )
          .then( resolve )
          .catch( reject );
      }
    });
  }

  deletePolicy = ( id ) => {
    return new Promise( ( resolve, reject ) => {
      this
        .DELETE( '/insurance/policies/' + id )
        .then( () => {
          this.getPolicies()
            .then( resolve )
            .catch( reject );
        })
        .catch( reject );
    });
  }

  getAttachmentForPolicy = ( id ) => {
    return new Promise( ( resolve, reject ) => {
      this.GET( '/insurance/attachments/list/' + id )
        .then( resolve )
        .catch( reject );
    });
  }

  deleteAttachment = ( policy, id ) => {
    return new Promise( ( resolve, reject ) => {
      this
        .DELETE( '/insurance/attachments/' + id )
        .then( () => {
          this.getAttachmentForPolicy( policy )
            .then( resolve )
            .catch( reject );
        })
        .catch( reject );
    });
  }

  sendAttachment = ( id ) => {
    return new Promise( ( resolve, reject ) => {
      this
        .GET( '/insurance/attachments/send/' + id )
        .then( resolve )
        .catch( reject );
    });
  }

  getCompanies = () => {
    return new Promise( ( resolve, reject ) => {
      this
        .GET( '/insurance/companies' )
        .then( resolve )
        .catch( reject );
    });
  }

  saveCompanies = ( values ) => {
    let endpoint = '/insurance/companies';

    return new Promise( ( resolve, reject ) => {
      if( values.id !== undefined ) {
        console.log( 'PUT', values );
        this
          .PUT( endpoint + '/' + values.id, values )
          .then( resolve )
          .catch( reject );
      } else {
        console.log( 'POST', values );
        this
          .POST( endpoint, values )
          .then( resolve )
          .catch( reject );
      }
    });
  }

  deleteCompanies = ( id ) => {
    return new Promise( ( resolve, reject ) => {
      this
        .DELETE( '/insurance/companies/' + id )
        .then( () => {
          this.getCompanies()
            .then( resolve )
            .catch( reject );
        })
        .catch( reject );
    });
  }

  getTypes = () => {
    return new Promise( ( resolve, reject ) => {
      this
        .GET( '/insurance/policy_types' )
        .then( resolve )
        .catch( reject );
    });
  }

  saveTypes = ( values ) => {
    let endpoint = '/insurance/policy_types';

    return new Promise( ( resolve, reject ) => {
      if( values.id !== undefined ) {
        console.log( 'PUT', values );
        this
          .PUT( endpoint + '/' + values.id, values )
          .then( resolve )
          .catch( reject );
      } else {
        console.log( 'POST', values );
        this
          .POST( endpoint, values )
          .then( resolve )
          .catch( reject );
      }
    });
  }

  deleteTypes = ( id ) => {
    return new Promise( ( resolve, reject ) => {
      this
        .DELETE( '/insurance/policy_types/' + id )
        .then( () => {
          this.getTypes()
            .then( resolve )
            .catch( reject );
        })
        .catch( reject );
    });
  }

  getSinesters = () => {
    return new Promise( ( resolve, reject ) => {
      this
        .GET( '/sinester/list' )
        .then( resolve )
        .catch( reject );
    });
  }

  saveSinester = ( values ) => {
    let endpoint = '/sinester/item';

    return new Promise( ( resolve, reject ) => {
      if( values.id !== undefined ) {
        console.log( 'PUT', values );
        this
          .PUT( endpoint + '/' + values.id, values )
          .then( resolve )
          .catch( reject );
      } else {
        console.log( 'POST', values );
        this
          .POST( endpoint, values )
          .then( resolve )
          .catch( reject );
      }
    });
  }

  deleteSinester = ( id ) => {
    return new Promise( ( resolve, reject ) => {
      this
        .DELETE( '/sinester/item/' + id )
        .then( () => {
          this.getSinesters()
            .then( resolve )
            .catch( reject );
        })
        .catch( reject );
    });
  }

  getSMTP = () => {
    return new Promise( ( resolve, reject ) => {
      this
        .GET( '/insurance/smtp' )
        .then( resolve )
        .catch( reject );
    });
  }

  saveSMTP = ( values ) => {
    let endpoint = '/insurance/smtp';

    return new Promise( ( resolve, reject ) => {
        this
          .POST( endpoint, values )
          .then( resolve )
          .catch( reject );
    });
  }

  getGeneral = () => {
    return new Promise( ( resolve, reject ) => {
      this
        .GET( '/insurance/general' )
        .then( resolve )
        .catch( reject );
    });
  }

  saveGeneral = ( values ) => {
    let endpoint = '/insurance/general';

    return new Promise( ( resolve, reject ) => {
        this
          .POST( endpoint, values )
          .then( resolve )
          .catch( reject );
    });
  }

  login = ( values ) => {
    return new Promise( ( resolve, reject ) => {
      this
        .POST( '/insurance/login', values )
        .then( resolve )
        .catch( reject );
  });
  }
}



// WEBPACK FOOTER //
// ./src/service/HttpService.jsx